import { render, staticRenderFns } from "./AdminAddPromotion2025.vue?vue&type=template&id=f86800b0&scoped=true"
import script from "./AdminAddPromotion2025.vue?vue&type=script&lang=js"
export * from "./AdminAddPromotion2025.vue?vue&type=script&lang=js"
import style0 from "./AdminAddPromotion2025.vue?vue&type=style&index=0&id=f86800b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86800b0",
  null
  
)

export default component.exports